import gql from 'graphql-tag';

const MUTATION_FORGOT_PASSWORD = gql`
  mutation forgotPassword($email: EmailAddress!) {
    forgotPassword(email: $email) {
      isSuccess
      message
    }
  }
`;

export default MUTATION_FORGOT_PASSWORD;
